
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ochrana-osobnich-udaju",
      function () {
        return require("private-next-pages/ochrana-osobnich-udaju.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ochrana-osobnich-udaju"])
      });
    }
  